import React, { useState, useEffect } from 'react';

const WelcomeModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const hasVisited = localStorage.getItem('hasVisitedQrOke');
    // Don't show the "use a computer" warning on guest song-request pages (/search/ or /join/)
    // — those pages work perfectly on mobile phones
    const path = window.location.pathname;
    const isGuestPage = path.includes('/search/') || path.includes('/join/');

    if (isMobile && !hasVisited && !isGuestPage) {
      setIsOpen(true);
      localStorage.setItem('hasVisitedQrOke', 'true');
    }
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg shadow-xl p-6 max-w-sm w-full text-white text-center">
        <h2 className="text-2xl font-bold mb-4">Welcome to QrOke!</h2>
        <p className="text-gray-300 mb-2">
          For the best <strong>host display</strong>, use a computer connected to a TV or cast your screen.
        </p>
        <p className="text-gray-400 text-sm mb-6">
          Guests requesting songs? You're all set — phones work great for that! 📱
        </p>
        <button
          onClick={() => setIsOpen(false)}
          className="w-full bg-qr-primary hover:bg-qr-secondary text-white font-bold py-2 px-4 rounded-lg transition-colors"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
